import './../../style/dragDrop.css';
import { useContext, useEffect, useState } from 'react';
import {parseContent} from "./util"
import {audioBaseURL } from "../../constants"


export default function DropElement({
        content, 
        identifier,
        currentDrag, 
        occupied, 
        informAboutOccupation}) {

    const [isBeingDraggedOver, setIsBeingDraggedOver] = useState(false)


    useEffect(() => {
        console.log("--------------------occupied-------------------------")
        console.log(occupied)
        if(!occupied){
            setIsBeingDraggedOver(false)
        }
    }, [occupied])



    function beingDraggedOver(event){
        event.stopPropagation();
        event.preventDefault();
        const data = event.dataTransfer.getData("text")
        setIsBeingDraggedOver(true)
    }

    function dragOverLeave(){
        setIsBeingDraggedOver(false)
    }

    function dragEnter(){
    }

    function drop(){
            informAboutOccupation(identifier)
    }




    return (
        <div>
            <div className={isBeingDraggedOver || occupied ? 'dndItem dropElement isBeingDraggedOver' : 'dndItem dropElement'} 
            onDragOver={beingDraggedOver} 
            onDragLeave={dragOverLeave} 
            onDragEnter={dragEnter}
            onDrop={drop}

            >
                <div className='flex flex-row'>
                { 
                //  <svg className="dropIcon w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 15">
                //      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 7.5h11m0 0L8 3.786M12 7.5l-4 3.714M12 1h3c.53 0 1.04.196 1.414.544.375.348.586.82.586 1.313v9.286c0 .492-.21.965-.586 1.313A2.081 2.081 0 0 1 15 14h-3"/>
                //  </svg>
                    }
                    <div className='ml-2'>{content}</div>
                </div>
            </div>
        {
            occupied && 
            <div className="droppedElement ">
                {parseContent(occupied.content).contentBeforeAudio && 
           //     <div>{occupied.content}</div>
           //TODO: content doesn't have contentBeforeAudio, audioFileName and contentAfterAudio yet! !!!!!!!!!!!!!!!!
                <div className=" "
                    dangerouslySetInnerHTML={{__html: parseContent(occupied.content).contentBeforeAudio}}
                />
                }
                {
                    parseContent(occupied.content).audioFileName && <audio controls src={audioBaseURL + parseContent(occupied.content).audioFileName}  ></audio>
                }
                {parseContent(occupied.content).contentAfterAudio && 
                <div className=" "
                    dangerouslySetInnerHTML={{__html: parseContent(occupied.content).contentAfterAudio}}
                />
                }
            </div>
        }
        </div>
        

                
    )
}

